import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-coral-blush"></div>
  </div>
);

export default LoadingSpinner;
